import {noop} from '@benchling/js-utils';

import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {standaloneProps} from 'notebook/simple-tables/SimpleTableEditable';
import {MaximumTableHeight} from 'notebook/tables/constants/TableLayoutConstants';
import {TableDimension} from 'notebook/tables/constants/TableSelectionConstants';

import booleanColumnInfoInitializer from './column-info-initializers/booleanColumnInfoInitializer';
import getNumericalColumnInfoInitializer from './column-info-initializers/getNumericalColumnInfoInitializer';
import jsonColumnInfoInitializer from './column-info-initializers/jsonColumnInfoInitializer';
import jsonListColumnInfoInitializer from './column-info-initializers/jsonListColumnInfoInitializer';
import {DataFrameToTableColumnInfoInitializer} from './DataFrameTableEditableTypes';

// These numbers were chosen because they looked good enough in testing.
/** @package */
export const DEFAULT_COLUMN_WIDTH = 100;
/** @package */
export const MAX_COLUMN_WIDTH = 200;
/** @package */
export const COLUMN_WIDTH_PER_HEADER_CHARACTER = 10;

/** @package */
export const LEAF_TYPE_TO_COLUMN_INFO_FN: {
  [key in LeafType]?: DataFrameToTableColumnInfoInitializer;
} = {
  [LeafType.JSON]: jsonColumnInfoInitializer,
  [LeafType.BOOLEAN]: booleanColumnInfoInitializer,
  [LeafType.DECIMAL]: getNumericalColumnInfoInitializer(LeafType.DECIMAL),
  [LeafType.INTEGER]: getNumericalColumnInfoInitializer(LeafType.INTEGER),
};

/** @package */
export const LIST_LEAF_TYPE_TO_COLUMN_INFO_FN: {
  [key in LeafType]?: DataFrameToTableColumnInfoInitializer;
} = {
  [LeafType.JSON]: jsonListColumnInfoInitializer,
};

/** @package */
export const SUPPORTED_LEAF_TYPES = Object.keys(LEAF_TYPE_TO_COLUMN_INFO_FN) as Array<LeafType>;
/** @package */
export const SUPPORTED_LIST_LEAF_TYPES = Object.keys(LIST_LEAF_TYPE_TO_COLUMN_INFO_FN) as Array<LeafType>;

// We disable almost all extra features of `SimpleTableEditable` to get a pure table editing experience.
/** @package */
export const DISABLED_SIMPLE_TABLE_PROPS = {
  ...standaloneProps,
  allowReorderDimensions: {
    [TableDimension.ROW]: false,
    [TableDimension.COLUMN]: false,
  },
  canAddColumnsFreeform: false,
  canAddRemoveColumns: false,
  hideColumnHeaderIcons: true,
  enableFormulas: false,
  hideFormulaBox: true,
  suppressTitleBar: true,
  isCollapsible: false,
  isLeftAlignRowHeader: true,
  maximumHeight: MaximumTableHeight.FULL,
  canRename: false,
  storeState: noop,
  restoreState: noop,
};
